// import RulePack from './RulePack';

export default {
  priority: 14,
  path: '',
  permissions: ['Forgivenwess'],
  // component: RulePack,
  component: load(() => import(/* webpackChunkName: "Request-pattern-RulePack" */ './Forgiveness')),
  name: app.translate('routes.home.requests.Definition'),
  icon: 'content-paste',
  drawer: true,
};


